import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=8c1cfd9a&scoped=true"
import script from "./DiscountForm.vue?vue&type=script&lang=js"
export * from "./DiscountForm.vue?vue&type=script&lang=js"
import style0 from "./DiscountForm.vue?vue&type=style&index=0&id=8c1cfd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1cfd9a",
  null
  
)

export default component.exports